<template>
  <div class="report-page" v-loading="loading">
    <template v-if="report">
      <!-- 汇总指标卡片 -->
      <el-row :gutter="16" class="summary-row">
        <el-col :span="6" v-for="item in report.summary" :key="item.label">
          <el-card shadow="hover" class="summary-card">
            <div class="summary-value">{{ item.value }}</div>
            <div class="summary-label">{{ item.label }}</div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 报表明细表格 -->
      <el-card shadow="never" class="table-card">
        <template #header>
          <span class="table-title">{{ report.title }}</span>
          <span class="table-tip">当前为模拟数据,后期由后端接口提供</span>
        </template>
        <el-table :data="report.rows" border stripe>
          <el-table-column
            v-for="col in report.columns"
            :key="col.prop"
            :prop="col.prop"
            :label="col.label"
            min-width="120"
          />
        </el-table>
      </el-card>
    </template>

    <el-empty v-else-if="!loading" description="暂无报表数据" />
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { getReport } from '@/api'

const route = useRoute()
const report = ref(null)
const loading = ref(false)

async function fetchData() {
  loading.value = true
  try {
    report.value = await getReport(route.meta.reportKey)
  } finally {
    loading.value = false
  }
}

// 切换报表路由时重新加载
watch(() => route.meta.reportKey, fetchData)

onMounted(fetchData)
</script>

<style scoped>
.summary-row {
  margin-bottom: 16px;
}
.summary-card {
  text-align: center;
}
.summary-value {
  font-size: 24px;
  font-weight: 700;
  color: #409eff;
}
.summary-label {
  margin-top: 6px;
  font-size: 13px;
  color: #909399;
}
.table-title {
  font-weight: 600;
}
.table-tip {
  margin-left: 12px;
  font-size: 12px;
  color: #909399;
}
</style>
